<template>
	<img class="max-h-full max-w-full object-contain mx-auto" :class="{ 'mt-1' : +team.team_id === 173}"
       ref="localTeamImg" :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
	     :data-src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${queryName}.png`" :alt="team.name"
       width="20" height="14"/>
</template>

<script>
import { lazyLoad } from '../../../../assets/js/utils.js';

export default {
	name: 'TeamImg',
	props: {
    team: Object,
    field: {
      type: String,
      default: 'query_name'
    }
  },
	mounted() {
		this.$nextTick(() => lazyLoad());
	},
	updated() {
		this.$nextTick(() => lazyLoad());
	},
  computed: {
    queryName() {
      if (this.team[this.field]) {
        return this.team[this.field];
      } else {
        return this.team.team_query_name;
      }
    }
  }
}
</script>